import { render, staticRenderFns } from "./OTSCredentialsConnection.vue?vue&type=template&id=72089529"
import script from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"
export * from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports